import { useState, useEffect } from "react";

/** Map i18next language codes to BCP47 tags for react-intl / Intl formatting. */
function toIntlLocaleTag(i18nLanguage: string): string {
  if (i18nLanguage.toLowerCase().startsWith("de")) {
    return "de-DE";
  }
  return "en-GB";
}

function useLocale() {
  const [locale, setLocale] = useState(
    toIntlLocaleTag(localStorage.getItem("i18nextLng") || "de"),
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setLocale(toIntlLocaleTag(localStorage.getItem("i18nextLng") || "de"));
    };

    window.addEventListener("languagechange", handleStorageChange);
    return () => {
      window.removeEventListener("languagechange", handleStorageChange);
    };
  }, []);

  return locale;
}

export default useLocale;
